import { styled } from '@mui/material';
import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

const CustomSvgIcon = styled(SvgIcon)(() => {
    return {
        color: 'transparent',
    };
});

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <CustomSvgIcon ref={ref} {...props} sx={{ color: 'transparent' }}>
            <mask id={id} style={{ maskType: 'alpha' }} maskUnits='userSpaceOnUse' x='0' y='0' width='24' height='24'>
                <circle cx='12' cy='12' r='12' fill='#D9D9D9' />
            </mask>
            <g mask={`url(#${id})`}>
                <rect x='-6' width='43.5' height='27.8115' fill='white' />
                <rect x='-6' width='43.5' height='2.13934' fill='#B91C1C' />
                <rect x='-6' y='4.27881' width='43.5' height='2.13934' fill='#B91C1C' />
                <rect x='-6' y='8.55762' width='43.5' height='2.13934' fill='#B91C1C' />
                <rect x='-6' y='12.8359' width='43.5' height='2.13934' fill='#B91C1C' />
                <rect x='-6' y='17.1143' width='43.5' height='2.13934' fill='#B91C1C' />
                <rect x='-6' y='21.3936' width='43.5' height='2.13934' fill='#B91C1C' />
                <rect x='-6' width='17.8279' height='14.9754' fill='#1A3272' />
                <path
                    d='M-0.306417 2.146L-0.150191 2.62681H0.355367L-0.0536382 2.92397L0.102588 3.40478L-0.306417 3.10762L-0.715422 3.40478L-0.559196 2.92397L-0.968201 2.62681H-0.462643L-0.306417 2.146Z'
                    fill='white'
                />
                <path
                    d='M2.71244 2.146L2.86867 2.62681H3.37423L2.96522 2.92397L3.12145 3.40478L2.71244 3.10762L2.30344 3.40478L2.45966 2.92397L2.05066 2.62681H2.55622L2.71244 2.146Z'
                    fill='white'
                />
                <path
                    d='M5.7313 2.146L5.88753 2.62681H6.39309L5.98408 2.92397L6.14031 3.40478L5.7313 3.10762L5.3223 3.40478L5.47852 2.92397L5.06952 2.62681H5.57508L5.7313 2.146Z'
                    fill='white'
                />
                <path
                    d='M8.75016 2.146L8.90639 2.62681H9.41195L9.00294 2.92397L9.15917 3.40478L8.75016 3.10762L8.34116 3.40478L8.49738 2.92397L8.08838 2.62681H8.59394L8.75016 2.146Z'
                    fill='white'
                />
                <path
                    d='M1.20298 0.754395L1.35921 1.23521H1.86477L1.45576 1.53237L1.61199 2.01318L1.20298 1.71602L0.793977 2.01318L0.950203 1.53237L0.541198 1.23521H1.04676L1.20298 0.754395Z'
                    fill='white'
                />
                <path
                    d='M4.22184 0.754395L4.37807 1.23521H4.88363L4.47462 1.53237L4.63085 2.01318L4.22184 1.71602L3.81284 2.01318L3.96906 1.53237L3.56006 1.23521H4.06562L4.22184 0.754395Z'
                    fill='white'
                />
                <path
                    d='M7.2407 0.754395L7.39693 1.23521H7.90249L7.49348 1.53237L7.64971 2.01318L7.2407 1.71602L6.8317 2.01318L6.98792 1.53237L6.57892 1.23521H7.08448L7.2407 0.754395Z'
                    fill='white'
                />
                <path
                    d='M10.2596 0.754395L10.4158 1.23521H10.9213L10.5123 1.53237L10.6686 2.01318L10.2596 1.71602L9.85056 2.01318L10.0068 1.53237L9.59778 1.23521H10.1033L10.2596 0.754395Z'
                    fill='white'
                />
                <path
                    d='M-0.306417 4.91895L-0.150191 5.39976H0.355367L-0.0536382 5.69692L0.102588 6.17773L-0.306417 5.88057L-0.715422 6.17773L-0.559196 5.69692L-0.968201 5.39976H-0.462643L-0.306417 4.91895Z'
                    fill='white'
                />
                <path
                    d='M-0.306417 7.93799L-0.150191 8.4188H0.355367L-0.0536382 8.71596L0.102588 9.19678L-0.306417 8.89962L-0.715422 9.19678L-0.559196 8.71596L-0.968201 8.4188H-0.462643L-0.306417 7.93799Z'
                    fill='white'
                />
                <path
                    d='M-0.306417 10.9561L-0.150191 11.4369H0.355367L-0.0536382 11.734L0.102588 12.2148L-0.306417 11.9177L-0.715422 12.2148L-0.559196 11.734L-0.968201 11.4369H-0.462643L-0.306417 10.9561Z'
                    fill='white'
                />
                <path
                    d='M2.71244 4.91895L2.86867 5.39976H3.37423L2.96522 5.69692L3.12145 6.17773L2.71244 5.88057L2.30344 6.17773L2.45966 5.69692L2.05066 5.39976H2.55622L2.71244 4.91895Z'
                    fill='white'
                />
                <path
                    d='M2.71244 7.93799L2.86867 8.4188H3.37423L2.96522 8.71596L3.12145 9.19678L2.71244 8.89962L2.30344 9.19678L2.45966 8.71596L2.05066 8.4188H2.55622L2.71244 7.93799Z'
                    fill='white'
                />
                <path
                    d='M2.71244 10.9561L2.86867 11.4369H3.37423L2.96522 11.734L3.12145 12.2148L2.71244 11.9177L2.30344 12.2148L2.45966 11.734L2.05066 11.4369H2.55622L2.71244 10.9561Z'
                    fill='white'
                />
                <path
                    d='M5.7313 4.91895L5.88753 5.39976H6.39309L5.98408 5.69692L6.14031 6.17773L5.7313 5.88057L5.3223 6.17773L5.47852 5.69692L5.06952 5.39976H5.57508L5.7313 4.91895Z'
                    fill='white'
                />
                <path
                    d='M5.7313 7.93799L5.88753 8.4188H6.39309L5.98408 8.71596L6.14031 9.19678L5.7313 8.89962L5.3223 9.19678L5.47852 8.71596L5.06952 8.4188H5.57508L5.7313 7.93799Z'
                    fill='white'
                />
                <path
                    d='M5.7313 10.9561L5.88753 11.4369H6.39309L5.98408 11.734L6.14031 12.2148L5.7313 11.9177L5.3223 12.2148L5.47852 11.734L5.06952 11.4369H5.57508L5.7313 10.9561Z'
                    fill='white'
                />
                <path
                    d='M8.75016 4.91895L8.90639 5.39976H9.41195L9.00294 5.69692L9.15917 6.17773L8.75016 5.88057L8.34116 6.17773L8.49738 5.69692L8.08838 5.39976H8.59394L8.75016 4.91895Z'
                    fill='white'
                />
                <path
                    d='M8.75016 7.93799L8.90639 8.4188H9.41195L9.00294 8.71596L9.15917 9.19678L8.75016 8.89962L8.34116 9.19678L8.49738 8.71596L8.08838 8.4188H8.59394L8.75016 7.93799Z'
                    fill='white'
                />
                <path
                    d='M8.75016 10.9561L8.90639 11.4369H9.41195L9.00294 11.734L9.15917 12.2148L8.75016 11.9177L8.34116 12.2148L8.49738 11.734L8.08838 11.4369H8.59394L8.75016 10.9561Z'
                    fill='white'
                />
                <path
                    d='M1.20298 3.52734L1.35921 4.00816H1.86477L1.45576 4.30532L1.61199 4.78613L1.20298 4.48897L0.793977 4.78613L0.950203 4.30532L0.541198 4.00816H1.04676L1.20298 3.52734Z'
                    fill='white'
                />
                <path
                    d='M1.20298 6.5459L1.35921 7.02671H1.86477L1.45576 7.32387L1.61199 7.80469L1.20298 7.50753L0.793977 7.80469L0.950203 7.32387L0.541198 7.02671H1.04676L1.20298 6.5459Z'
                    fill='white'
                />
                <path
                    d='M1.20298 9.56445L1.35921 10.0453H1.86477L1.45576 10.3424L1.61199 10.8232L1.20298 10.5261L0.793977 10.8232L0.950203 10.3424L0.541198 10.0453H1.04676L1.20298 9.56445Z'
                    fill='white'
                />
                <path
                    d='M1.20298 12.584L1.35921 13.0648H1.86477L1.45576 13.362L1.61199 13.8428L1.20298 13.5456L0.793977 13.8428L0.950203 13.362L0.541198 13.0648H1.04676L1.20298 12.584Z'
                    fill='white'
                />
                <path
                    d='M4.22184 3.52734L4.37807 4.00816H4.88363L4.47462 4.30532L4.63085 4.78613L4.22184 4.48897L3.81284 4.78613L3.96906 4.30532L3.56006 4.00816H4.06562L4.22184 3.52734Z'
                    fill='white'
                />
                <path
                    d='M4.22184 6.5459L4.37807 7.02671H4.88363L4.47462 7.32387L4.63085 7.80469L4.22184 7.50753L3.81284 7.80469L3.96906 7.32387L3.56006 7.02671H4.06562L4.22184 6.5459Z'
                    fill='white'
                />
                <path
                    d='M4.22184 9.56445L4.37807 10.0453H4.88363L4.47462 10.3424L4.63085 10.8232L4.22184 10.5261L3.81284 10.8232L3.96906 10.3424L3.56006 10.0453H4.06562L4.22184 9.56445Z'
                    fill='white'
                />
                <path
                    d='M4.22184 12.584L4.37807 13.0648H4.88363L4.47462 13.362L4.63085 13.8428L4.22184 13.5456L3.81284 13.8428L3.96906 13.362L3.56006 13.0648H4.06562L4.22184 12.584Z'
                    fill='white'
                />
                <path
                    d='M7.2407 3.52734L7.39693 4.00816H7.90249L7.49348 4.30532L7.64971 4.78613L7.2407 4.48897L6.8317 4.78613L6.98792 4.30532L6.57892 4.00816H7.08448L7.2407 3.52734Z'
                    fill='white'
                />
                <path
                    d='M7.2407 6.5459L7.39693 7.02671H7.90249L7.49348 7.32387L7.64971 7.80469L7.2407 7.50753L6.8317 7.80469L6.98792 7.32387L6.57892 7.02671H7.08448L7.2407 6.5459Z'
                    fill='white'
                />
                <path
                    d='M7.2407 9.56445L7.39693 10.0453H7.90249L7.49348 10.3424L7.64971 10.8232L7.2407 10.5261L6.8317 10.8232L6.98792 10.3424L6.57892 10.0453H7.08448L7.2407 9.56445Z'
                    fill='white'
                />
                <path
                    d='M7.2407 12.584L7.39693 13.0648H7.90249L7.49348 13.362L7.64971 13.8428L7.2407 13.5456L6.8317 13.8428L6.98792 13.362L6.57892 13.0648H7.08448L7.2407 12.584Z'
                    fill='white'
                />
                <path
                    d='M10.2596 3.52734L10.4158 4.00816H10.9213L10.5123 4.30532L10.6686 4.78613L10.2596 4.48897L9.85056 4.78613L10.0068 4.30532L9.59778 4.00816H10.1033L10.2596 3.52734Z'
                    fill='white'
                />
                <path
                    d='M10.2596 6.5459L10.4158 7.02671H10.9213L10.5123 7.32387L10.6686 7.80469L10.2596 7.50753L9.85056 7.80469L10.0068 7.32387L9.59778 7.02671H10.1033L10.2596 6.5459Z'
                    fill='white'
                />
                <path
                    d='M10.2596 9.56445L10.4158 10.0453H10.9213L10.5123 10.3424L10.6686 10.8232L10.2596 10.5261L9.85056 10.8232L10.0068 10.3424L9.59778 10.0453H10.1033L10.2596 9.56445Z'
                    fill='white'
                />
                <path
                    d='M10.2596 12.584L10.4158 13.0648H10.9213L10.5123 13.362L10.6686 13.8428L10.2596 13.5456L9.85056 13.8428L10.0068 13.362L9.59778 13.0648H10.1033L10.2596 12.584Z'
                    fill='white'
                />
            </g>
            <circle cx='12' cy='12' r='11.75' stroke='#D3D2D7' strokeWidth='0.5' />
        </CustomSvgIcon>
    );
});
